import { Base, createApp } from '@studiometa/js-toolkit';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import Accordion from './components/Sections/Accordion/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      Accordion,
    },
  };
}

export default createApp(App, document.documentElement);
